import { Box, IconButton, Tooltip, Typography } from '@mui/material'
import { DataGrid, GridToolbar } from '@mui/x-data-grid'
import { useStyles } from './styles'
import { useBody } from './body'
import { FiltersDrawer } from '../../../../components/filtersDrawer'
import { DinamicForm } from '../../../../components/dinamicForm'
import { icons } from '../../../../utils/icons'
import { useNavigate } from 'react-router-dom'
import { GoBack } from '../../../../components/goBack'
import { esESGrid } from '../programation/utils/esEs'
import { useTranslation } from 'react-i18next'
import { BreadCrumb } from '../../../../components'

const ReportPropgramatioProgressQuestionnaire = () => {
  const {
    loading,
    columns,
    row,
    input,
    errors,
    counter,
    filterData,
    queryParams,
    refreshTable,
    onChange,
    cleanFIlters,
  } = useBody()
  const styles = useStyles()
  const navigate = useNavigate()
  const { t } = useTranslation()
  return (
    <Box sx={styles.container}>
      {/* FLOATS */}
      <BreadCrumb
        removeBreadcrumb={['reports']}
        replaceLabels={{ 'progress-questionnaire': 'progressQuestionnaireByUnitys' }}
      />
      <FiltersDrawer
        cleanFilter={cleanFIlters}
        count={counter}
        right={0}
        top={50}
      >
        <Box sx={styles.section}>
          <DinamicForm
            errors={errors}
            input={Object.values({
              ...input,
              from: {
                ...input?.from,
                rest: {
                  ...filterData?.intervale?.value === '1w' ? {
                    shouldDisableDate: (date: Date) => {

                      return new Date(date.valueOf())?.getDay?.() !== 1 || (filterData?.to && new Date(date.valueOf()) > filterData?.to)
                    },
                    textField: {
                      disabled: true
                    }
                  } : {
                    shouldDisableDate: (date: Date) => {
                      if (!filterData?.to) return false
                      return new Date(date.valueOf()) > filterData?.to
                    },

                  }
                }
              }
            })}
            values={filterData}
            onChange={onChange}
          />
        </Box>
      </FiltersDrawer>

      {
        !!queryParams.size && (
          <GoBack path='/dashboard' />
        )
      }

      <Box sx={styles.header}>

        <Typography variant='title_grey_big'>
          Avance de cuestionarios por unidades
        </Typography>

        <Box>
          <Tooltip title={t('ToolTips.refresh')}>
            <IconButton
              onClick={() => {
                refreshTable()
              }}
            >
              {icons('refresh')}
            </IconButton>
          </Tooltip>

          {(counter || 0) > 0 && (
            <Tooltip title={t('ToolTips.clearFilters')}>
              <IconButton
                sx={(styles.clean, (counter || 0) > 0 ? null : styles.hide)}
                onClick={() => {
                  cleanFIlters()
                }}
              >
                {icons('clean')}
              </IconButton>
            </Tooltip>
          )}
        </Box>
      </Box>

      <DataGrid
        columns={columns}
        rows={row ?? []}
        getRowId={(row) => row.id}
        autoHeight
        loading={loading}
        slots={{ toolbar: GridToolbar }}
        localeText={esESGrid}
        disableDensitySelector
        disableColumnMenu
        initialState={{
          columns: {
            columnVisibilityModel: {
              unidad: true,
              usuario: true,
              cuestionario: true,
              fecha_inicio_programacion: true,
              fecha_fin_programacion: true,
              fecha_inicio_respuesta: true,
              fecha_fin_respuesta: true,
              avance: true,
              resultado: true,
              cuestionario_estatus: true,
              division_unidad: false,
              zona: false,
              division_usuario: false,
              tipo_usuario: false,
              area: false,
              departamento: false,
              tipo_programacion: false,
            },
          },
        }}
        getRowHeight={() => 'auto'}
        scrollbarSize={17}
        hideScrollbar={false}
        sx={{
          '& .MuiDataGrid-cell': {
            whiteSpace: 'normal !important',
            wordWrap: 'break-word',
            lineHeight: '1.3',
            padding: '8px',
            alignItems: 'flex-start'
          },
          '& .MuiDataGrid-row': {
            maxHeight: 'none !important'
          },
          '& .MuiDataGrid-main': {
            '& ::-webkit-scrollbar': {
              width: '12px',
              height: '12px'
            },
            '& ::-webkit-scrollbar-track': {
              background: '#f1f1f1',
              borderRadius: '10px'
            },
            '& ::-webkit-scrollbar-thumb': {
              background: '#888',
              borderRadius: '10px',
              '&:hover': {
                background: '#555'
              }
            }
          }
        }}
        slotProps={{
          toolbar: {
            printOptions: { disableToolbarButton: true },
            csvOptions: { fileName: 'Avance de cuestionarios por unidades', },
          },
          filterPanel: {
            logicOperators: [],
            filterFormProps: {
              operatorInputProps: {
                disabled: true,
                sx: { display: 'none' },
              },
            },
          },
          pagination: {
            labelRowsPerPage: '',
          },
        }}
      />
    </Box>
  )
}

export { ReportPropgramatioProgressQuestionnaire }
